// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".isDisabled[data-v-041e6958] {\n  opacity: 0.3;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
